import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  Evaluation,
  EvaluationInterface,
} from 'app/assessment/evaluation/models';
import { ReviewInterface } from 'app/assessment/models/review.model';
import { AppStateInterface } from 'app/core/app-config/state/models';
import { EntityConnectorInterface } from 'app/core/connector-services/entity-connector-service.interface';
import { RestConnectorService } from 'app/core/connector-services/rest-connector-service/rest-connector-service.abstract';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class EvaluationRestConnectorService extends RestConnectorService implements EntityConnectorInterface<EvaluationInterface> {

  constructor(private readonly _httpClient: HttpClient,
              protected readonly _store: Store<AppStateInterface>) {
    super(_store);
  }

  public loadAll(): Observable<EvaluationInterface[]> {
    return of([this.generateMockEvaluation()]);
  }

  public loadAllByUserId(userId: number): Observable<EvaluationInterface[]> {
    return this._httpClient.get<EvaluationInterface[]>(
      `/api/users/${userId}/evaluations`,
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<EvaluationInterface[]>) => {
        return <EvaluationInterface[]>httpResponse.body;
      }),
    );
  }

  public loadOne(id: number): Observable<EvaluationInterface> {
    throw new Error('Method not implemented.');
  }

  public loadCurrentEvaluation(userId: number, evaluationId: number): Observable<Readonly<EvaluationInterface>> {
    let evaluationEndpoint: string = `/api/users/${userId}/evaluations/new`;
    if (evaluationId) {
      evaluationEndpoint = `/api/users/${userId}/evaluations/${evaluationId}`;
    }

    return this._httpClient.get<EvaluationInterface>(
      evaluationEndpoint,
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<EvaluationInterface>) => {

        /*In complete Servey*/
        if(!httpResponse.body.haveCompletedSurvey) {
          const serveyPagesArray:any = ['7-1', '8-1', '9-1', '10-1', '11-1'];
          const serveyPagesListArray:any = httpResponse.body.pages.filter((item:any)=>serveyPagesArray.includes(item.id));
          let updatedPages:any = [];

          serveyPagesListArray.map((list:any)=> {
            list.questionGroups.map((inner:any)=> {
              inner.questions.map((sample: any)=> {
                // child Questions
                if(sample.childQuestionTriggers.length>0) {
                  sample.childQuestions.map((cq: any)=> {
                    cq.answers.map((cans: any)=> {
                      return cans;
                    });
                    return cq;
                  });
                }


                sample.answers.map((item:any)=> {
                  return item;
                });
                return sample;
              });
              return inner;
            });

            updatedPages= httpResponse.body.pages.map((item:any) => {
              if(item.id===list.id) {
                return list;
              }
              return item;

            });
            return list;
          });
          httpResponse.body.pages= updatedPages;
        }
        /*End Servey*/



        return httpResponse.body;
      }),
    );
  }

  public update(entity: EvaluationInterface): Observable<EvaluationInterface> {

    return this._httpClient.put<EvaluationInterface>(
      `/api/users/${entity.subject.id}/evaluations`,
      entity,
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<EvaluationInterface>) => {
        let evaluation: EvaluationInterface;
        if (httpResponse.status === 204 && !httpResponse.body) {
          evaluation = entity;
        } else {
          evaluation = <EvaluationInterface>httpResponse.body;
        }
        return evaluation;
      }),
    );
  }

  public addNewReviewComment(text: string, userId: number, evalId: number): Observable<ReviewInterface> {
    const authorId: number = this._authenticatedUser$.value.id;
    const body: {} = {
      text,
      author: {
        id: authorId,
      },
    };

    return this._httpClient.post<ReviewInterface>(
      `api/users/${userId}/evaluations/${evalId}/reviews`,
      body,
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<ReviewInterface>) => {
        let review: ReviewInterface;
        if (httpResponse.status === 204 && !httpResponse.body) {
          review = body;
        } else {
          review = <ReviewInterface>httpResponse.body;
        }
        return review;
      }),
    );
  }

  public updateReviewComment(updatedReview: ReviewInterface, userId: number, evalId: number): Observable<ReviewInterface> {
    return this._httpClient.put<ReviewInterface>(
      `api/users/${userId}/evaluations/${evalId}/reviews`,
      updatedReview,
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<ReviewInterface>) => {
        let review: ReviewInterface;
        if (httpResponse.status === 204 && !httpResponse.body) {
          // review = updatedReview;
        } else {
          review = <ReviewInterface>httpResponse.body;
        }
        return review;
      }),
    );
  }

  public deleteReviewComment(deletedReview: ReviewInterface, userId: number, evalId: number): Observable<ReviewInterface> {
    return this._httpClient.delete<ReviewInterface>(
      `api/users/${userId}/evaluations/${evalId}/reviews/${deletedReview.id}`,
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<ReviewInterface>) => {
        let review: ReviewInterface;
        if (httpResponse.status === 204 && !httpResponse.body) {
          // review = deletedReview;
        } else {
          review = <ReviewInterface>httpResponse.body;
        }
        return review;
      }),
    );
  }

  /**
   * Generate a mock Evaluation object from the actual return values from the evaluation endpoint.
   */
  public generateMockEvaluation(): EvaluationInterface {

    /* tslint:disable:max-line-length */
    const json: any = {
    };
    /* tslint:enable:max-line-length */

    json.date = new Date(json.date);
    return new Evaluation(json);
  }
}
